export default __webpack_public_path__ + "static/back--23-5d80886b12c1dbf7e21fee85568cd7f0.webp";